import { InMemoryCache } from '@websolutespa/payload-plugin-bowl';
import { ResponseSuccess } from '@websolutespa/payload-utils/server';
import { PayloadHandler, PayloadRequest } from 'payload';
import { fetchRobot } from '../utils/robot';
import { errorHandler } from './error.handler';
import { RobotTool } from './types';

const CACHE_ = new InMemoryCache<RobotTool[]>();

export const llmToolsHandler: PayloadHandler = async (req: PayloadRequest) => {
  try {
    let tools: RobotTool[];

    const cacheKey = 'robot_tools';
    if (CACHE_.has(cacheKey)) {
      tools = CACHE_.get(cacheKey);
    }
    else {
      tools = await fetchRobot<RobotTool[]>('api/llm/extension/tools', 'GET');
      CACHE_.set(cacheKey, tools);
    }

    return ResponseSuccess(tools);
  } catch (error: any) {
    return errorHandler(error);
  }
};
